import Color from '@/Enums/Color.enum';
import { Paper } from '@mui/material';
import PropTypes from 'prop-types';

const getDefaultContent = () => (
  <>
    <div className='font-bold text-[38px] text-center'>No Results found</div>
    <div className='font-medium text-[20px] max-w-[480px] text-center'>
      We couldn’t find anything. Please refine your search or try different keywords.
    </div>
  </>
);

const NoDataCard = ({ renderContent = getDefaultContent, sx = {}, ...contentProps }) => {
  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: Color.NoDataCard,
        height: '500px',
        ...sx,
      }}
    >
      <svg width='258' height='235' viewBox='0 0 258 235' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M124.198 182.88C172.643 182.88 211.918 143.605 211.918 94.9868C211.918 46.3688 172.47 7.09375 124.198 7.09375C75.7531 7.09375 36.478 46.3688 36.478 94.9868C36.478 143.605 75.7531 182.88 124.198 182.88Z'
          fill='#EAEEF9'
        />
        <path
          d='M206.208 37.372C210.126 37.372 213.302 34.1961 213.302 30.2783C213.302 26.3605 210.126 23.1846 206.208 23.1846C202.291 23.1846 199.115 26.3605 199.115 30.2783C199.115 34.1961 202.291 37.372 206.208 37.372Z'
          fill='#E7EBF6'
        />
        <path
          d='M216.589 9.689C219.265 9.689 221.434 7.52004 221.434 4.8445C221.434 2.16896 219.265 0 216.589 0C213.914 0 211.745 2.16896 211.745 4.8445C211.745 7.52004 213.914 9.689 216.589 9.689Z'
          fill='#E7EBF6'
        />
        <path
          d='M41.1497 37.1988C43.8252 37.1988 45.9942 35.0298 45.9942 32.3543C45.9942 29.6787 43.8252 27.5098 41.1497 27.5098C38.4741 27.5098 36.3052 29.6787 36.3052 32.3543C36.3052 35.0298 38.4741 37.1988 41.1497 37.1988Z'
          fill='#E7EBF6'
        />
        <path
          d='M11.5633 130.629C16.5322 130.629 20.5603 126.601 20.5603 121.632C20.5603 116.663 16.5322 112.635 11.5633 112.635C6.59447 112.635 2.56641 116.663 2.56641 121.632C2.56641 126.601 6.59447 130.629 11.5633 130.629Z'
          fill='#E7EBF6'
        />
        <g filter='url(#filter0_d_687_3824)'>
          <path
            d='M149.632 48.2722L176.104 143.432C176.969 146.719 175.066 150.007 171.778 150.872L78.5217 175.613C75.2343 176.478 71.947 174.575 71.0819 171.288L38.5546 48.4452C37.6895 45.1578 39.5927 41.8705 42.88 41.0054L110.357 23.1846L149.632 48.2722Z'
            fill='url(#paint0_linear_687_3824)'
          />
        </g>
        <path
          d='M148.248 108.482L97.8995 121.805L92.3629 123.189L75.5802 127.687C74.8881 127.86 74.3691 128.725 74.7151 129.591C74.8881 130.456 75.7532 130.975 76.4453 130.802L93.228 126.303L98.7646 124.919L149.113 111.597C149.805 111.424 150.324 110.559 149.978 109.693C149.805 108.828 148.94 108.309 148.248 108.482Z'
          fill='#D5DDEA'
        />
        <path
          d='M144.961 96.7173L126.275 101.562L119.873 103.292L72.6393 115.922C71.9472 116.095 71.4282 116.96 71.7742 117.825C71.9472 118.691 72.8123 119.21 73.5044 119.037L120.911 106.406L127.313 104.676L145.999 99.8316C146.691 99.6586 147.21 98.7935 146.864 97.9284C146.518 97.2364 145.653 96.5443 144.961 96.7173Z'
          fill='#D5DDEA'
        />
        <path
          d='M142.192 84.7791L137.348 85.9903L132.503 87.2014L69.3517 103.984C68.6596 104.157 68.1406 105.022 68.4866 105.887C68.6596 106.752 69.5247 107.271 70.2168 107.098L133.368 90.3157L138.732 88.9316L143.057 87.7204C143.749 87.5474 144.268 86.6823 143.922 85.8172C143.749 85.1252 143.057 84.6061 142.192 84.7791Z'
          fill='#D5DDEA'
        />
        <path
          d='M112.952 146.027L109.492 146.892C108.8 147.065 107.935 146.546 107.762 145.681C107.589 144.816 107.935 143.951 108.627 143.778L112.087 142.913C112.779 142.74 113.644 143.259 113.817 144.124C113.991 145.162 113.644 145.854 112.952 146.027Z'
          fill='#CED7E2'
        />
        <path
          d='M102.398 148.795L82.5008 153.986C81.8088 154.159 80.9437 153.64 80.7707 152.775C80.5976 151.91 80.9437 151.045 81.6357 150.872L101.533 145.681C102.225 145.508 103.09 146.027 103.263 146.892C103.609 147.757 103.263 148.622 102.398 148.795Z'
          fill='#D5DDEA'
        />
        <path
          d='M139.77 72.8409L124.025 76.9933L120.219 78.0314L66.4103 92.2189C65.7182 92.3919 65.1992 93.257 65.5452 94.122C65.7182 94.9871 66.5833 95.5062 67.2754 95.3332L120.911 81.3187L124.717 80.2806L140.289 76.1282C141.154 75.9552 141.5 75.0901 141.327 74.052C141.327 73.3599 140.462 72.6678 139.77 72.8409Z'
          fill='#D5DDEA'
        />
        <path
          d='M102.571 46.7153L57.9327 58.4805C56.8946 58.8265 55.8565 58.1344 55.5104 57.0963C55.1644 56.0582 55.8565 55.0201 56.8946 54.6741L101.533 42.9089C102.571 42.5628 103.609 43.2549 103.955 44.293C104.301 45.3311 103.609 46.3692 102.571 46.7153Z'
          fill='#D5DDEA'
        />
        <path
          d='M78.0028 64.7089L60.8741 69.2074C59.836 69.5534 58.7979 68.8613 58.4518 67.8232C58.1058 66.7851 58.7979 65.747 59.836 65.401L76.7917 60.9025C77.8298 60.5565 78.8679 61.2485 79.214 62.2867C79.56 63.3248 78.8679 64.3629 78.0028 64.7089Z'
          fill='#D5DDEA'
        />
        <path
          d='M110.357 23.1846L117.278 49.4833C118.316 53.1167 122.295 55.3659 125.929 54.3278L149.632 48.2722'
          fill='#D5DDEA'
        />
        <g filter='url(#filter1_d_687_3824)'>
          <path
            d='M219.531 75.0897L203.613 172.672C203.094 175.959 199.807 178.208 196.52 177.516L101.706 160.906C98.4184 160.387 96.1692 157.1 96.6883 153.813L118.662 28.7209C119.181 25.4336 122.468 23.1843 125.755 23.8764L194.616 35.9876L219.531 75.0897Z'
            fill='url(#paint1_linear_687_3824)'
          />
        </g>
        <path
          d='M193.059 129.244L141.845 120.247L136.309 119.209L119.18 116.268C118.488 116.095 117.623 116.787 117.623 117.652C117.45 118.517 117.969 119.382 118.661 119.555L135.79 122.497L141.326 123.535L192.54 132.532C193.232 132.705 194.097 132.013 194.097 131.147C194.27 130.282 193.924 129.417 193.059 129.244Z'
          fill='#CED7E2'
        />
        <path
          d='M195.135 117.306L176.103 114.018L169.702 112.807L121.43 104.329C120.737 104.156 119.872 104.848 119.872 105.714C119.699 106.579 120.218 107.444 120.911 107.617L169.182 116.095L175.584 117.306L194.616 120.593C195.308 120.766 196.173 120.074 196.173 119.209C196.346 118.344 195.827 117.479 195.135 117.306Z'
          fill='#CED7E2'
        />
        <path
          d='M197.557 105.194L192.54 104.329L187.522 103.464L123.16 92.2181C122.467 92.0451 121.602 92.7371 121.602 93.6022C121.429 94.4673 121.948 95.3324 122.64 95.5054L187.003 106.752L192.54 107.79L196.865 108.482C197.557 108.655 198.422 107.963 198.422 107.098C198.768 106.233 198.422 105.367 197.557 105.194Z'
          fill='#D5DDEA'
        />
        <path
          d='M145.306 148.622L141.846 148.103C141.153 147.93 140.634 147.065 140.807 146.2C140.98 145.335 141.673 144.643 142.365 144.816L145.825 145.335C146.517 145.508 147.036 146.373 146.863 147.238C146.69 148.276 145.998 148.622 145.306 148.622Z'
          fill='#CED7E2'
        />
        <path
          d='M134.752 146.719L114.509 143.259C113.817 143.086 113.298 142.221 113.471 141.356C113.644 140.491 114.336 139.798 115.028 139.972L135.271 143.432C135.963 143.605 136.482 144.47 136.309 145.335C136.136 146.373 135.444 146.892 134.752 146.719Z'
          fill='#E3EAF2'
        />
        <path
          d='M200.326 93.4295L184.235 90.6612L180.256 89.9691L125.409 80.2801C124.717 80.1071 123.852 80.7992 123.852 81.6642C123.679 82.5293 124.198 83.3944 124.89 83.5674L179.737 93.2564L183.716 93.9485L199.634 96.7168C200.499 96.8898 201.191 96.1977 201.364 95.3326C201.537 94.4676 201.018 93.6025 200.326 93.4295Z'
          fill='#D5DDEA'
        />
        <path
          d='M177.661 54.1545L132.157 46.1957C131.119 46.0227 130.427 44.9846 130.6 43.9464C130.773 42.9083 131.811 42.2163 132.849 42.3893L178.353 50.3481C179.391 50.5211 180.083 51.5592 179.91 52.5973C179.737 53.4624 178.699 54.3275 177.661 54.1545Z'
          fill='#D5DDEA'
        />
        <path
          d='M147.728 60.0371L130.254 56.9227C129.215 56.7497 128.523 55.7116 128.696 54.6735C128.869 53.6354 129.908 52.9433 130.946 53.1163L148.247 56.2307C149.286 56.4037 149.978 57.4418 149.805 58.4799C149.632 59.518 148.593 60.2101 147.728 60.0371Z'
          fill='#D5DDEA'
        />
        <path
          d='M194.443 35.9878L189.771 62.8056C189.079 66.6119 191.848 70.2453 195.654 70.9374L219.53 75.0898'
          fill='#D5DDEA'
        />
        <path
          d='M154.303 163.502C175.611 163.502 192.886 146.228 192.886 124.919C192.886 103.61 175.611 86.3359 154.303 86.3359C132.994 86.3359 115.72 103.61 115.72 124.919C115.72 146.228 132.994 163.502 154.303 163.502Z'
          fill='white'
        />
        <path
          d='M150.669 131.147C150.496 130.455 150.496 129.763 150.496 128.898C150.496 125.957 151.707 123.362 154.822 121.112L157.417 119.209C158.974 117.998 159.666 116.614 159.666 114.884C159.666 112.461 157.936 110.039 154.303 110.039C150.496 110.039 148.766 113.154 148.766 116.095C148.766 116.787 148.766 117.306 148.939 117.825L142.018 117.652C141.845 116.96 141.672 116.095 141.672 115.23C141.672 109.347 145.998 103.811 154.13 103.811C162.434 103.811 166.933 109.174 166.933 114.538C166.933 118.863 164.684 121.804 161.569 124.054L159.32 125.611C157.417 126.995 156.379 128.725 156.379 130.801V131.147H150.669ZM153.611 134.608C156.033 134.608 157.936 136.511 157.936 138.933C157.936 141.355 156.033 143.259 153.611 143.259C151.188 143.259 149.285 141.355 149.285 138.933C149.458 136.684 151.188 134.608 153.611 134.608Z'
          fill='#989FB0'
        />
        <path
          d='M212.055 184.824C210.558 184.824 209.06 184.225 207.862 182.877L182.852 157.867L181.953 158.466C173.866 164.456 164.431 167.601 154.846 167.601C143.314 167.601 131.783 162.959 123.246 154.872C114.261 146.335 109.318 134.803 109.318 122.223C109.318 97.2129 129.686 76.8452 154.696 76.8452C171.769 76.8452 186.746 85.831 194.833 101.107C202.77 116.233 201.722 133.905 191.987 148.132L191.388 149.031L216.548 174.191C219.094 176.737 218.495 179.283 218.046 180.631C216.848 183.027 214.452 184.824 212.055 184.824ZM154.696 89.2755C136.425 89.2755 121.749 104.102 121.749 122.223C121.749 142.89 138.672 155.321 155.146 155.321C165.18 155.321 174.315 150.828 180.755 142.741C188.692 132.856 190.04 119.528 184.499 107.996C178.808 96.4641 167.426 89.2755 154.696 89.2755Z'
          fill='#989FB0'
        />
        <defs>
          <filter
            id='filter0_d_687_3824'
            x='0.282276'
            y='4.15261'
            width='214.094'
            height='228.765'
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='19.032' />
            <feGaussianBlur stdDeviation='19.032' />
            <feColorMatrix type='matrix' values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0' />
            <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_687_3824' />
            <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_687_3824' result='shape' />
          </filter>
          <filter
            id='filter1_d_687_3824'
            x='58.5499'
            y='4.71902'
            width='199.045'
            height='230.018'
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='19.032' />
            <feGaussianBlur stdDeviation='19.032' />
            <feColorMatrix type='matrix' values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0' />
            <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_687_3824' />
            <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_687_3824' result='shape' />
          </filter>
          <linearGradient
            id='paint0_linear_687_3824'
            x1='107.284'
            y1='19.6539'
            x2='107.284'
            y2='177.467'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#FDFEFF' />
            <stop offset='0.9964' stopColor='#ECF0F5' />
          </linearGradient>
          <linearGradient
            id='paint1_linear_687_3824'
            x1='158.032'
            y1='20.1913'
            x2='158.032'
            y2='179.301'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#FDFEFF' />
            <stop offset='0.9964' stopColor='#ECF0F5' />
          </linearGradient>
        </defs>
      </svg>
      {renderContent(contentProps)}
    </Paper>
  );
};

NoDataCard.propTypes = {
  renderContent: PropTypes.func,
  sx: PropTypes.object,
};

export default NoDataCard;
